/* eslint-disable @typescript-eslint/no-unused-vars */
import axios from "axios";
import _ from "lodash";
import { ACCESS_TOKEN } from "../utils/constants";
import packageJson from "../../package.json";
import { pubsub, PubSubKeys } from "../utils/pubsub";
const WEB_VERSION = packageJson.version;
const api = axios.create({
  baseURL:
    process.env.REACT_APP_API_BASE_URL ||
    "https://test-ultra-middleware.azurewebsites.net",
  headers: {
    "Content-Type": "application/json",
    "x-ultra-agent": `ultra-web-customer-booking-${WEB_VERSION}`,
  },
});

api.interceptors.request.use((config: { headers: any }) => {
  const accessToken = localStorage.getItem(ACCESS_TOKEN);
  (config.headers || {}).Authorization = `Bearer ${accessToken}`;
  return config;
});

api.interceptors.response.use(
  (response: any) => response,
  async (error: { response: { status: number } }) => {
    if (error.response.status === 401) {
      const accessToken = localStorage.getItem(ACCESS_TOKEN);
      if (accessToken) {
        localStorage.removeItem(ACCESS_TOKEN);
        pubsub.publish(PubSubKeys.LOGOUT, "utm_content=no_access_token");
      }
    }

    const errorTitle = _.get(error, "response.data.title", "");

    // if (!_.isEmpty(errorTitle)) {
    //   toast.error(errorTitle);
    // }

    return Promise.reject(_.get(error, "response.data", {}));
  }
);

export default api;
